import { Phone, Clock, ShieldCheck, MapPin, Mail } from "lucide-react";
import { PHONE, COMPANY } from "@/lib/siteConfig";

export const ContactSection = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="ss-section relative overflow-hidden"
    >
      <div className="absolute inset-0 ss-hero-bg" aria-hidden="true" />
      <div className="absolute inset-0 ss-grain pointer-events-none" aria-hidden="true" />

      <div className="ss-container relative">
        <div className="rounded-3xl bg-[#071A2B]/70 backdrop-blur border border-white/10 p-8 sm:p-12 lg:p-16 text-center shadow-[0_30px_80px_rgba(0,0,0,0.4)]">
          <span className="ss-eyebrow-on-navy">Kontakt</span>
          <h2 className="ss-h2 mt-4 text-white">
            Sichern Sie Ihre Immobilie –{" "}
            <span className="text-[var(--ss-gold)]">jetzt anrufen.</span>
          </h2>
          <p className="ss-lead mt-4 text-slate-300 max-w-2xl mx-auto">
            Unverbindliches Beratungsgespräch, transparente Konditionen, deutschlandweiter Einsatz. Kein Formular, kein Warten – wir gehen sofort ans Telefon.
          </p>

          <a
            href={`tel:${PHONE.tel}`}
            className="mt-10 inline-flex items-center gap-3 rounded-2xl bg-[var(--ss-gold)] text-[#071A2B] px-6 sm:px-8 py-5 sm:py-6 shadow-[0_20px_60px_rgba(245,197,66,0.35)] hover:shadow-[0_25px_70px_rgba(245,197,66,0.45)] active:scale-[0.99] transition-all"
            data-testid="contact-phone-cta"
          >
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#071A2B] text-[var(--ss-gold)]">
              <Phone className="h-5 w-5" strokeWidth={2.5} />
            </span>
            <span className="text-left">
              <span className="block text-xs uppercase tracking-widest font-semibold text-[#0A2340]/70">Direkt anrufen</span>
              <span
                className="block font-display font-bold text-2xl sm:text-3xl leading-none mt-0.5"
                data-testid="contact-phone-number"
              >
                {PHONE.display}
              </span>
            </span>
          </a>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4 text-sm">
            <a
              href={`mailto:${COMPANY.email}`}
              className="inline-flex items-center gap-2 rounded-xl border border-white/20 bg-white/5 px-4 py-2.5 text-slate-200 hover:bg-white/10 hover:border-[var(--ss-gold)]/40 transition"
              data-testid="contact-email-cta"
            >
              <Mail className="h-4 w-4 text-[var(--ss-gold)]" />
              {COMPANY.email}
            </a>
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto text-sm text-slate-300">
            <div className="rounded-xl bg-white/5 border border-white/10 p-4">
              <Clock className="h-4 w-4 text-[var(--ss-gold)] mx-auto" />
              <div className="mt-2 font-semibold text-white">Erreichbarkeit</div>
              <div className="text-xs text-slate-400 mt-1">{PHONE.hours}</div>
            </div>
            <div className="rounded-xl bg-white/5 border border-white/10 p-4">
              <ShieldCheck className="h-4 w-4 text-[var(--ss-gold)] mx-auto" />
              <div className="mt-2 font-semibold text-white">Beratung</div>
              <div className="text-xs text-slate-400 mt-1">Unverbindlich &amp; kostenfrei</div>
            </div>
            <div className="rounded-xl bg-white/5 border border-white/10 p-4">
              <MapPin className="h-4 w-4 text-[var(--ss-gold)] mx-auto" />
              <div className="mt-2 font-semibold text-white">Standort</div>
              <div className="text-xs text-slate-400 mt-1">{COMPANY.city} · Deutschlandweit im Einsatz</div>
            </div>
          </div>

          <div className="mt-8 inline-flex items-start gap-3 text-left text-xs text-slate-400 bg-white/5 border border-white/10 rounded-xl px-5 py-4">
            <MapPin className="h-4 w-4 text-[var(--ss-gold)] mt-0.5 shrink-0" />
            <address className="not-italic leading-relaxed">
              <span className="text-white font-semibold">{COMPANY.name}</span> · Inhaber {COMPANY.owner}<br />
              {COMPANY.street}, {COMPANY.postalCode} {COMPANY.city}
            </address>
          </div>
        </div>
      </div>
    </section>
  );
};
